module.exports = __webpack_public_path__ + "img/bj2.2257a883.png";